import { render, staticRenderFns } from "./alertInfo.vue?vue&type=template&id=abf64a76&scoped=true"
import script from "./alertInfo.vue?vue&type=script&lang=js"
export * from "./alertInfo.vue?vue&type=script&lang=js"
import style0 from "./alertInfo.vue?vue&type=style&index=0&id=abf64a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf64a76",
  null
  
)

export default component.exports